import {
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import Confirm from "../../../components/confirm/Confirm";
import { Table } from "../../../components/datatable/DataTable";
import ErrorScreen from "../../../components/error/ErrorScreen";
import Loader from "../../../components/Loader";
import { getCokkie } from "../../login/Login";

const EvaluationTablestream = forwardRef(
  (
    {
      id,
      eval_data,
      _id,
      created_by,
      onDataChange,
      setLoadingState,
      callStart,
      evaluation,
      isTeriminated,
      setIsTerminated,
      callStartDelete,
      callStartTerminate,
      pageSize = 16,
      onStreamSettled,
    },
    ref
  ) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);
    const [deleteUrl, setDeleteUrl] = useState();
    const [refreshTick, setRefreshTick] = useState(0);

    const pagesize = Math.max(16, Number(pageSize) || 16);

    // main worker drives the visible table
    const workerRef = useRef(null);
    // keep stable refs for callbacks
    const onDataChangeRef = useRef(onDataChange);
    const onStreamSettledRef = useRef(onStreamSettled);
    useEffect(() => {
      onDataChangeRef.current = onDataChange;
      onStreamSettledRef.current = onStreamSettled;
    }, [onDataChange, onStreamSettled]);

    // ---------------- Main worker: drives visible table ----------------
    useEffect(() => {
      try {
        // console.log("message from table component isTeriminated", isTeriminated);
      } catch {}
      if (setIsTerminated) setIsTerminated(false);

      const token = getCokkie("jwtToken");
      if (!token) {
        console.error("JWT token not found.");
        setLoading(false);
        if (setLoadingState) setLoadingState(false);
        return;
      }

      const streamUrl = id
        ? `${window.ENV.API_URL}/models/detailed/${id}/device_table`
        : `${window.ENV.API_URL}/models?filters={"_id":"${_id}","created_by":"${created_by}"}&section=evaluation_history&page=1&page_size=${pagesize}`;

      // Clean previous worker
      if (workerRef.current) {
        try {
          workerRef.current.terminate();
        } catch {}
        workerRef.current = null;
      }

      const worker = new Worker(
        new URL("../../../worker/sseWorker.js", import.meta.url),
        { type: "module" }
      );
      workerRef.current = worker;

      worker.postMessage({ streamUrl, token });

      worker.onmessage = function (e) {
        const { type, data: payload, message } = e.data || {};

        switch (type) {
          case "message": {
            // Defensive guard: a transient availability event is not table data.
            // Keep the last rendered history until the worker retry succeeds.
            if (
              String(payload?.error ?? "").trim().toLowerCase() ===
              "model-api unavailable"
            ) {
              break;
            }
            setData(payload); // drives visible table
            if (onDataChangeRef.current) onDataChangeRef.current(payload, 1);
            setLoading(false);
            if (setLoadingState) setLoadingState(false);
            onStreamSettledRef.current?.();
            break;
          }
          case "retry": {
            // The worker is reconnecting. Intentionally preserve data/loading
            // state so there is no empty-table flash between streams.
            break;
          }
          case "error": {
            console.error("SSE Worker Error:", message);
            setLoading(false);
            if (setLoadingState) setLoadingState(false);
            onStreamSettledRef.current?.();
            break;
          }
          case "done": {
            if (workerRef.current === worker) {
              try {
                worker.terminate();
              } catch {}
              workerRef.current = null;
            }
            setLoading(false);
            if (setLoadingState) setLoadingState(false);
            onStreamSettledRef.current?.();
            break;
          }
          default:
            break;
        }
      };

      return () => {
        if (workerRef.current) {
          try {
            workerRef.current.terminate();
          } catch {}
          workerRef.current = null;
        }
      };
      // IMPORTANT: do NOT depend on callStart; refreshTick handles explicit refreshes.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, _id, created_by, pagesize, isTeriminated, refreshTick, callStartDelete, callStartTerminate]);

    // Refresh the same cumulative page without clearing the current payload.
    useEffect(() => {
      if (!callStart) return;
      setRefreshTick((tick) => tick + 1);
    }, [callStart]);


    // inject delete cell
    if (eval_data?.inference_version_table?.columns?.[5]) {
      eval_data.inference_version_table.columns[5].Cell = (e) => (
        <div className="d-flex">
          <FontAwesomeIcon
            className="mt-1 mx-3 cursor-pointer"
            icon={faTrash}
            onClick={() =>
              setDeleteUrl(
                `${window.ENV.API_URL}/models/${id}/${e.cell.row.values.eval_id}?confirm=`
              )
            }
          />
        </div>
      );
    }

    // Big blocking loader (when used) – while shown, clicks are blocked via isBusy anyway
    if (loading && !(data?.device_table?.data?.length > 0)) {
      return <Loader />;
    }

    // Prefer showing streamed 'data.device_table' whenever present;
    // if it's absent, fall back to eval_data table so UI never goes blank.
    const showStreamTable = Boolean(data?.device_table?.columns);
    const showEvalTable = Boolean(eval_data?.inference_version_table?.columns);

    return (
      <>
        {!data && !eval_data && (
          <ErrorScreen message={"No Evaluation Table Found"} />
        )}

        <div
          className={`mt-0 ${
            evaluation === "Evaluation" && "evaluation-table2"
          } table-default w-100 table-overflow`}
          style={{ minHeight: evaluation === "Evaluation" ? "280px" : "" }}
        >
          {/* {showStreamTable && (
            <Table
              columns={data.device_table.columns}
              data={data.device_table.data}
              model_name={_id}
              rows={evaluation === "Evaluation" && 5}
            />
          )}

          {!showStreamTable && showEvalTable && (
            <Table
              columns={eval_data.inference_version_table.columns}
              data={eval_data.inference_version_table.data}
            />
          )} */}
        </div>

        {deleteUrl && (
          <Confirm url={deleteUrl} close={() => setDeleteUrl(undefined)} />
        )}
      </>
    );
  }
);

export default EvaluationTablestream;
